/* Cryptid Emporium — Expedition theme. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---------- Mobile nav drawer ---------- */
    var navToggle = document.querySelector('[data-nav-toggle]');
    var nav = document.querySelector('[data-nav]');
    var overlay = document.querySelector('[data-nav-overlay]');

    function setNav(open) {
      if (!navToggle || !nav) return;
      nav.classList.toggle('is-open', open);
      document.body.classList.toggle('nav-open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (overlay) overlay.hidden = !open;
      if (open) {
        var first = nav.querySelector('a, button');
        if (first) first.focus();
      } else {
        navToggle.focus();
      }
    }

    if (navToggle && nav) {
      navToggle.addEventListener('click', function () {
        setNav(!nav.classList.contains('is-open'));
      });
      if (overlay) {
        overlay.addEventListener('click', function () { setNav(false); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) setNav(false);
      });
    }

    /* ---------- Header dropdowns (click-toggled, close on outside/Escape) ---------- */
    var dropdowns = document.querySelectorAll('[data-dropdown]');
    function closeDropdowns(except) {
      dropdowns.forEach(function (dd) {
        if (dd === except) return;
        dd.classList.remove('is-open');
        var t = dd.querySelector('[data-dropdown-toggle]');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    dropdowns.forEach(function (dd) {
      var t = dd.querySelector('[data-dropdown-toggle]');
      if (!t) return;
      t.addEventListener('click', function () {
        var open = dd.classList.toggle('is-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        closeDropdowns(dd);
      });
    });
    if (dropdowns.length) {
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-dropdown]')) closeDropdowns(null);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDropdowns(null);
      });
    }

    /* ---------- Product gallery ---------- */
    var mainImg = document.querySelector('[data-gallery-main]');
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');
    if (mainImg && thumbs.length) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mainImg.src = btn.dataset.full;
          mainImg.removeAttribute('srcset');
          mainImg.alt = btn.dataset.alt || mainImg.alt;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    }

    /* ---------- Variant picker (multi-option, radio buttons) ---------- */
    var productJsonEl = document.querySelector('[data-product-json]');
    var productForm = document.querySelector('[data-product-form]');
    if (productJsonEl && productForm) {
      var productData;
      try { productData = JSON.parse(productJsonEl.textContent); } catch (err) { productData = null; }

      if (productData) {
        var variantInput = productForm.querySelector('[data-variant-id]');
        var addBtn = productForm.querySelector('[data-add-btn]');
        var addBtnText = productForm.querySelector('[data-add-btn-text]');
        var priceEl = document.querySelector('[data-price]');
        var compareEl = document.querySelector('[data-compare-price]');
        var optionFieldsets = productForm.querySelectorAll('[data-option-index]');

        var selectedOptions = [];
        optionFieldsets.forEach(function (fs, i) {
          var checked = fs.querySelector('[data-option-value]:checked');
          selectedOptions[i] = checked ? checked.value : null;
        });

        function findVariant() {
          return productData.variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
          });
        }

        function updateUI() {
          var variant = findVariant();
          if (variant) {
            if (variantInput) variantInput.value = variant.id;
            if (priceEl) priceEl.innerHTML = variant.price;
            if (compareEl) {
              if (variant.compare_at_price) {
                compareEl.innerHTML = variant.compare_at_price;
                compareEl.hidden = false;
              } else {
                compareEl.hidden = true;
              }
            }
            if (addBtn) {
              addBtn.disabled = !variant.available;
              if (addBtnText) {
                addBtnText.textContent = variant.available
                  ? productData.strings.add_to_cart
                  : productData.strings.sold_out;
              }
            }
          } else if (addBtn) {
            addBtn.disabled = true;
            if (addBtnText) addBtnText.textContent = productData.strings.unavailable;
          }
        }

        optionFieldsets.forEach(function (fs, i) {
          var label = fs.querySelector('[data-option-selected]');
          fs.querySelectorAll('[data-option-value]').forEach(function (input) {
            input.addEventListener('change', function () {
              selectedOptions[i] = input.value;
              if (label) label.textContent = input.value;
              updateUI();
            });
          });
        });

        if (optionFieldsets.length) updateUI();
      }
    }

    /* ---------- Cart quantity steppers ---------- */
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-qty-input]');
      if (!input) return;
      var submitTimer = null;
      function queueSubmit() {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () {
          var form = input.closest('form');
          if (form) form.submit();
        }, 500);
      }
      wrap.querySelectorAll('button[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.dataset.step === 'up' ? 1 : -1;
          input.value = Math.max(0, (parseInt(input.value, 10) || 0) + step);
          queueSubmit();
        });
      });
      input.addEventListener('change', queueSubmit);
    });

    /* ---------- Collection sort ---------- */
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sortSelect.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* ---------- Field Guide search + region filter ---------- */
    var guideSearch = document.querySelector('[data-encyclopedia-search]');
    var regionBtns = document.querySelectorAll('[data-region]');
    var entries = document.querySelectorAll('[data-entry]');
    var emptyNote = document.querySelector('[data-empty-note]');
    var activeRegion = 'all';

    function applyFilters() {
      var q = guideSearch ? guideSearch.value.trim().toLowerCase() : '';
      var shown = 0;
      entries.forEach(function (el) {
        var haystack = (el.dataset.search || '').toLowerCase();
        var regionOk = activeRegion === 'all' || el.dataset.entryRegion === activeRegion;
        var textOk = !q || haystack.indexOf(q) !== -1;
        var visible = regionOk && textOk;
        el.style.display = visible ? '' : 'none';
        if (visible) shown++;
      });
      document.querySelectorAll('[data-region-group]').forEach(function (group) {
        var any = false;
        group.querySelectorAll('[data-entry]').forEach(function (el) {
          if (el.style.display !== 'none') any = true;
        });
        group.style.display = any ? '' : 'none';
      });
      if (emptyNote) emptyNote.style.display = shown ? 'none' : '';
    }

    if (guideSearch) guideSearch.addEventListener('input', applyFilters);
    regionBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activeRegion = btn.dataset.region;
        regionBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        applyFilters();
      });
    });

    /* All-pill count = real entry total (entries render from a generated snippet) */
    var allBtn = document.querySelector('[data-all-count]');
    if (allBtn && entries.length) allBtn.textContent = 'All · ' + entries.length;
  });
})();
